import React from "react";
import { Link } from "react-router-dom";
import Home from "./home";

export default function Chasebank() {
  return (
    <div className="PageContent">
      <Home />
      <div className="tableDiv table-responsive content_centered colored_background push_downwards">
        <table className="table table-responsive">
          <thead>
            <tr>
              <th scope="col">LOGS NAME</th>
              <th scope="col">Description</th>
              <th scope="col">includes</th>
              <th scope="col">Balances</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,354.21</td>
              <td>$111</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,532.74</td>
              <td>$140</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,828.83</td>
              <td>$160</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,195.53</td>
              <td>$213</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,523.48</td>
              <td>$230</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$2,835.00</td>
              <td>$253</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3.027.01</td>
              <td>$309</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,263.55</td>
              <td>$335</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,474.90</td>
              <td>$360</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,870.44</td>
              <td>$370</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$1,353.75</td>
              <td>$350</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr>
              <th scope="row">Chase Bank Logs</th>
              <td>Chase Savings Account</td>
              <td>
                {" "}
                Onine Access,Email Access,, Security Questions , And Answers
                SSN, Card Infomation, ,Address, Support Pin
              </td>
              <td>$3,585.43</td>
              <td>$342</td>
              <td title="live">
                <div className="liveDot"></div>
              </td>
              <td>
                {" "}
                <Link to="/addfunds">
                  {" "}
                  <button className="Buy_now_btn">Buy Now</button>{" "}
                </Link>
              </td>
            </tr>
            <tr className="table_last_row">
              <th scope="col">LOGS NAME</th>
              <th scope="col">Description</th>
              <th scope="col">includes</th>
              <th scope="col">Balances</th>
              <th scope="col">price</th>
              <th scope="col">status</th>
              <th scope="col">Buy now</th>
            </tr>
          </tbody>
        </table>
      </div>
      <footer className="footer">
        <p> &copy;2023 Darknetlogs Logs Shop</p>
      </footer>
    </div>
  );
}
